import { firestore } from 'firebase'

export interface CardStatus {
    hp: number;
    atk: number;
    def: number;
    agi: number;
    dex: number;
    int: number;
}

export interface CardDesign {
    backgroundColor: string;
}

export interface KaiwaCard {
    cardId?: string;
    deckId?: string;
    title: string;
    description: string;
    conversations: string[];
    attribute: string;
    visiblity: 'unlisted' | 'public' | 'private';
    rarity: number;
    status: CardStatus;
    design: CardDesign;
    createdAt?: firestore.Timestamp;
    updatedAt?: firestore.Timestamp;
}

export const initialCard: KaiwaCard = {
    title: '',
    description: '',
    visiblity: 'unlisted',
    conversations: ['', '', ''],
    attribute: 'なし',
    rarity: 1,
    status: {
        hp: 50,
        atk: 50,
        def: 50,
        agi: 50,
        dex: 50,
        int: 50
    },
    design: {
        backgroundColor: '#FFFFFF'
    }
}

export const attributeList: string[] = []